import Chart from "chart.js";
import dayjs from "dayjs";

/**
 * Função padrão para converter dados de label do Chart do tipo data que irá formatar no titulo do tooltip
 * @param format Opcional - Padrão = "DD [d]e MMM (ddd)"
 * @returns Retorna a função que deve ser inserida no callback do title do tooltip
 */
export function title(format?: string) {
  if (!format) format = "DD [d]e MMM (ddd)";
  return (i: Chart.ChartTooltipItem[]) => dayjs("" + i[0].label).format(format);
}

/**
 * Função padrão para converter dados label do Chart do tipo data que irão aparecer no eixo x ou y do gráfico
 * @param format Opcional - Padrão = "DD"
 * @returns Retorna a função que deve ser inserida no callback do ticks xAxes ou yAxes array (primeira posição do array)
 */
export function ticks(format?: string) {
  if (!format) format = "DD";
  return (val: number | string) => dayjs(val).format(format).toUpperCase();
}
